import { useEffect, useState } from 'react';

/**
 * Reads a JSON value from localStorage, falling back when the key is absent,
 * corrupt, or storage is unavailable (private mode, disabled cookies).
 */
export const readStored = (key, fallback) => {
  try {
    const stored = localStorage.getItem(key);

    return stored === null ? fallback : JSON.parse(stored);
  } catch {
    return fallback;
  }
};

export const writeStored = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage unavailable — the value still works for this session.
  }
};

/**
 * useState that survives unmount/navigation. List-page filters are plain
 * useState, so navigating away and back resets them to their defaults.
 */
export const usePersistentState = (key, initialValue) => {
  const [value, setValue] = useState(() => readStored(key, initialValue));

  useEffect(() => {
    writeStored(key, value);
  }, [key, value]);

  return [value, setValue];
};
